export const selectCompany = state => state.company;
